import './RegionPanel.css';
import { Card } from '../../components/Card';
import { CardHeader } from '../../components/CardHeader';
import { t } from '../../copy/strings';
import { isPreHeadline } from '../../model/headline';
import { openPlace } from '../../state/actions';
import { useConfig, useHeadline, useLayout, useNowMinute, useStatics, useTimeline, useView } from '../../state/hooks';
import { regionRows } from './model';
import { RegionRow } from './RegionRow';

/** id do título (o `Card` aponta `aria-labelledby` para ele, §15.4.1). */
export const REGION_PANEL_TITLE_ID = 'region-panel-title';

/** Clique, Enter ou Espaço na linha do Exterior (§7.12 bloco 5; AC-7.12-04): `#/presidente/exterior`. */
const openAbroad = () => openPlace({ kind: 'abroad' });

/**
 * "Por região" (§7.12): quem lidera para presidente em cada região, com quanto, quanto falta e a variação contra o 2º
 * turno de 2022; a linha do Exterior abre o Exterior. Seis linhas em ordem fixa e chave estável (código da região):
 * uma atualização nunca recria a linha focada (§15.2.2 regra 4). Antes das 17h00 (manchete pré-resultado, E01) nenhum
 * percentual de candidato aparece (AC-7.17-03). Oculto em `data-h` short/tiny (`.u-mid-up`, AC-7.12-06) e na TV
 * (`.tv-hide`; a coluna direita da TV só existe em cena com foco, D07).
 */
export function RegionPanel() {
  const view = useView();
  const statics = useStatics();
  const { live, displayTMin } = useTimeline();
  const { mode } = useLayout();
  const features = useConfig().features;
  const pre = isPreHeadline(useHeadline());
  const ex = view?.regions.EX ?? null;
  // Urnas fechadas no exterior (§7.12 bloco 3): ao vivo, pelo relógio da fonte (às 17h00 o snapshot ainda é das 16h30);
  // no replay, pelo instante exibido. O tique de `now` só é assinado enquanto o Exterior não tem votos.
  const abroadNoVotes = pre || ex === null || ex.validVotes === 0;
  const shown = view?.instantTMin ?? displayTMin;
  const abroadTMin = !abroadNoVotes ? shown : live ? Math.max(useNowMinute(), view?.instantTMin ?? 0) : shown;
  const rows = regionRows({ view, pre, geography: statics.geography, baseline: statics.baseline, abroadTMin });
  const tv = mode === 'tv';
  const abroadClickable = features.abroad && !tv;
  return (
    <Card class="region-panel u-mid-up tv-hide" data-testid="region-panel" labelledBy={REGION_PANEL_TITLE_ID}>
      <CardHeader
        title={t('regions.title')}
        titleId={REGION_PANEL_TITLE_ID}
        aside={tv ? undefined : t('regions.aside')}
      />
      <ul class="region-panel__list">
        {rows.map((m) => (
          <RegionRow
            key={m.code}
            model={m}
            photos={features.photos}
            onOpen={m.code === 'EX' && abroadClickable ? openAbroad : undefined}
          />
        ))}
      </ul>
    </Card>
  );
}
